import { render } from "./작성글_답변완료_상세페이지.vue?vue&type=template&id=19a4bdaa"
import script from "./작성글_답변완료_상세페이지.vue?vue&type=script&lang=js"
export * from "./작성글_답변완료_상세페이지.vue?vue&type=script&lang=js"

import "./작성글_답변완료_상세페이지.vue?vue&type=style&index=0&id=19a4bdaa&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__